"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELLO_WORLD = exports.BUNDLES = exports.REQUEST = exports.LANG = exports.LOCAL = exports.PROXY_SECURE = exports.PURL = exports.REFUS = exports.ERROR = exports.DETAILS = exports.STACK = exports.INPUT = exports.KEY_UP = exports.KEY_DOWN = exports.CLICK = exports.NO = exports.YES = exports.CALL_BACK = exports.UP = exports.RESPONSE = exports.MESSAGE = exports.STATUS = exports.ON = void 0;
exports.ON = 'on';
exports.STATUS = 'status';
exports.MESSAGE = 'message';
exports.RESPONSE = 'response';
exports.UP = 'UP';
exports.CALL_BACK = 'callback';
exports.YES = 'yes';
exports.NO = 'no';
exports.CLICK = 'click';
exports.KEY_DOWN = 'keydown';
exports.KEY_UP = 'keyup';
exports.INPUT = 'input';
exports.STACK = 'stack';
exports.DETAILS = 'details';
exports.ERROR = 'ERROR';
exports.REFUS = 'refus';
exports.PURL = 'purl';
exports.PROXY_SECURE = 'proxySecure';
exports.LOCAL = 'locale';
exports.LANG = 'lang';
exports.REQUEST = '[REQUEST]';
exports.BUNDLES = '../../bundles';
exports.HELLO_WORLD = 'Hello world';
